import type {FC} from 'react';

import type {Props} from './types';

import {CreditCard} from '../../../../components/CreditCard';
import {Checkbox} from '../../../../uikit/Checkbox';
import * as S from './styles';

export const CardsListItemJSX: FC<Props> = ({
  brand,
  expMonth,
  expYear,
  isSelected,
  last4Digits,
  ...rest
}) => {
  return (
    <S.Container isSelected={isSelected} {...rest}>
      <S.CardContainer>
        <CreditCard
          brand={brand}
          expMonth={expMonth}
          expYear={expYear}
          last4Digits={last4Digits}
          variant="small"
        />
        <S.Number>{`**** ${last4Digits}`}</S.Number>
      </S.CardContainer>
      <Checkbox checked={isSelected} scheme="secondary" variant="circle" />
    </S.Container>
  );
};
